import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "register-section" }
const _hoisted_2 = { class: "register-container" }
const _hoisted_3 = { class: "register-header" }
const _hoisted_4 = {
  key: 0,
  class: "register-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "register-warning"
}
const _hoisted_6 = { class: "register-footer" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { MailOutlined, LockOutlined, UserOutlined  } from '@ant-design/icons-vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { Auth } from '@/lib/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const form = ref({
  email: '',
  password: '',
  first_name: '',
  last_name: '',
  confirmPassword: '',
});

const isInProcess = ref(false);
const isWarning = ref(false);
const message = ref('');
const router = useRouter();
 
const validateConfirmPassword = async (_: any, value: string) => {
  if (value !== form.value.password) {
    return Promise.reject('Passwords do not match!');
  }
  return Promise.resolve();
};

const register = async () => {
  isInProcess.value = true;
  isWarning.value = false;
  message.value = '';

  try {
    const result = await Auth.register({
      email: form.value.email,
      password: form.value.password,
      confirmPassword: form.value.confirmPassword, 
      first_name: form.value.first_name,
      last_name: form.value.last_name,
    });

    if (result.success) {
      router.push('/login');
    } else {
      isWarning.value = true;
      message.value = result.error || 'Registration failed.';
    }
  } catch (err : any) {
    isWarning.value = true;
    message.value = err.response?.data?.message || err.response?.data?.error || 'Email and password are required.';
  } finally {
    isInProcess.value = false;
  }
};


return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_typography_link = _resolveComponent("a-typography-link")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createStaticVNode("<svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-7af15fbe><rect x=\"0.464\" width=\"24\" height=\"24\" rx=\"4.8\" fill=\"#1890FF\" data-v-7af15fbe></rect><path d=\"M14.864 3.6H20.864V9.6H14.864V3.6Z\" fill=\"white\" data-v-7af15fbe></path><path d=\"M10.064 9.6H14.864V14.4H10.064V9.6Z\" fill=\"white\" data-v-7af15fbe></path><path d=\"M4.064 13.2H11.264V20.4H4.064V13.2Z\" fill=\"white\" data-v-7af15fbe></path></svg>", 1)),
        _createVNode(_component_a_typography_title, {
          class: "register-title",
          level: 2
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Register", -1)
          ])),
          _: 1,
          __: [5]
        }),
        _createVNode(_component_a_typography_text, { class: "register-text" }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" Welcome! Please enter your information to register. ", -1)
          ])),
          _: 1,
          __: [6]
        })
      ]),
      (isInProcess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(LoadingSpinner, { color: "#1890FF" })
          ]))
        : _createCommentVNode("", true),
      (isWarning.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(message.value), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_a_form, {
        layout: "vertical",
        model: form.value,
        onFinish: register
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "First Name",
            name: "first_name",
            rules: [{ required: true, message: 'Please enter your first name!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: form.value.first_name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.first_name) = $event)),
                placeholder: "First Name",
                autocomplete: "off"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_unref(UserOutlined))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Last Name",
            name: "last_name",
            rules: [{ required: true, message: 'Please enter your last name!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: form.value.last_name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.last_name) = $event)),
                placeholder: "Last Name",
                autocomplete: "off"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_unref(UserOutlined))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Email",
            name: "email",
            rules: [{ required: true, type: 'email', message: 'Please enter your email!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: form.value.email,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.email) = $event)),
                placeholder: "Email",
                autocomplete: "off"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_unref(MailOutlined))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Password",
            name: "password",
            rules: [{ required: true, message: 'Please enter your password!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                value: form.value.password,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.password) = $event)),
                placeholder: "Password",
                autocomplete: "off"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_unref(LockOutlined))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Confirm Password",
            name: "confirmPassword",
            rules: [
            { required: true, message: 'Please confirm your password!' },
            { validator: validateConfirmPassword }
          ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                value: form.value.confirmPassword,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.confirmPassword) = $event)),
                placeholder: "Confirm Password",
                autocomplete: "new-password"
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_unref(LockOutlined))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                block: ""
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Register", -1)
                ])),
                _: 1,
                __: [8]
              }),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_typography_text, { class: "register-text" }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("Already have an account?", -1)
                  ])),
                  _: 1,
                  __: [9]
                }),
                _createVNode(_component_a_typography_link, { href: "/login" }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode(" Login ", -1)
                  ])),
                  _: 1,
                  __: [10]
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ])
  ]))
}
}

})